'use strict';

import Form from '../utils/Form';

class Offers {
  constructor() {
    $('.menu.desktop.r .menu_offers').addClass('active');

    new Form().done((data) => {
      if (data.status == 200) {
        var str = location.pathname;
        if (str.charAt(str.length - 1) !== '/') {
          str = str + '/';
        }
        location.href = location.origin + str + 'completado/' + location.search;
      }
    });

    //Modal
    var modal = document.getElementById('myModal');

    var btn = document.getElementById('termsBtn');

    var span = document.getElementsByClassName('closeModal')[0];

    if (btn) {
      btn.onclick = function() {
        modal.style.display = 'block';
      };
    }

    if (span) {
      span.onclick = function() {
        modal.style.display = 'none';
      };
    }

    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = 'none';
      }
    };
  }
}

export default Offers;
